import type { ReactNode } from 'react';

// https://www.solidjs.com/docs/latest/api#show
export function Show<T>({
    when,
    fallback,
    children,
}: {
    when: T | undefined | null | false;
    fallback?: ReactNode;
    children: ReactNode | ((item: NonNullable<T>) => ReactNode);
}): ReactNode {
    return when
        ? typeof children === 'function'
            ? children(when as NonNullable<T>)
            : children
        : (fallback ?? null);
}
